<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <!--{{listData}}-->
        <!-- <div class="row pr-3 pl-3 mb-3 justify-content-end">
          <Button label="Export to excel" class="main-style-button" @click="exportCSV()" />
        </div> -->
        <BaseDatatable :key="componentKey" @selectedService="selectedService" :tableData="listData" :model="dataModel" @onRowSelect="onRowSelect" :options="options"
          :filterDefault="filters" :getFilterOptions="getFilterOptions" :actions="getRowActions()"
          v-on:action-click="onActionClicked" 
          v-on:action-list_select_item="action_list_select_item"
          @filterData="changeFilterData"></BaseDatatable>
        <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
          Are you want to delete this Log management ?
          <template #footer>

            <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
            <Button label="Confirm" @click="deleteData()" icon="pi pi-check"
                    class="p-button-danger  btn-confirm-delete-dialog" />
          </template>
        </Dialog>
        <Dialog header="Notification" :visible.sync="showReadDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
          Do you want to read the announcement?
          <template #footer>

            <Button label="Cancel" @click="showReadDialog = false" icon="pi pi-times" class="p-button-warning" />
            <Button label="Confirm" @click="readData()" icon="pi pi-check"
                    class="p-button-danger  btn-confirm-delete-dialog" />
          </template>
        </Dialog>
        <Dialog header="Notification"
        :visible.sync="showAdminNoteDialog"
        :contentStyle="{ overflow: 'visible' }"
        :modal="true">

  <!-- Textarea nhập admin note -->
  <div class="p-field">
    <label for="admin_note">Admin's Note</label>
    <Textarea id="admin_note"
              v-model="AdminNoteString"
              rows="4"
              cols="50"
              autoResize
               />
  </div>

  <template #footer>
    <Button label="Cancel"
            @click="showAdminNoteDialog = false"
            icon="pi pi-times"
            class="p-button-warning" />
    <Button label="Confirm"
            @click="adminNoteData()"
            icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog" />
  </template>
</Dialog>

      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
import ApiRepository from "@/core/ApiRepository";
// import gql from "graphql-tag";
// import Popup from './popup'
export default {
  components: {
    BaseDatatable
    // Popup
  },
  data() {
    return {
      filters: {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      countRelationship: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      AdminNoteId: null,
      showAdminNoteDialog: false,
      AdminNoteString: null,
      readId: null,
      showReadDialog: false,
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      whereKeyList: {
        where_key: {
          /*accounts: {
            role: {_eq: "admin"},
            deleted: {_eq: false}
          },*/
          deleted: { _eq: false }
        }
      },
      page_transaction: null,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      colorArr: [
        '#BBB2F9',
        '#F8D8AB',
        '#BBEFA8',
        '#A7C3FA',
        '#F3B1AF'
      ],
      filterData: {},
      selected: null,

      list_order_item_id:[]
    }
  },
  mounted() {
    this.initParams();
  }
  ,
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if (this.$route.params.reload) {
      window.location.reload();
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_LOG_MANAGEMENT);
    if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0) {
      this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
    }
    // console.log("arr_role:" ,arr_role)
    this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false : true;
    this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false : true;
    this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false : true;
    // var arr_role_clubs = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_CLUBS);
    // // console.log('role_clubrole_club',arr_role_clubs)
    // if (arr_role_clubs.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.view_club = false;
    // }else{
    //   this.view_club = true;
    // }
    // console.log('this.view',this.view_club)
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
     action_list_select_item(data) {
      //Lấy danh sách đơn hàng
      this.list_order_item_id = data["list_order_item_id"]
    },
    onRowSelect(data) {
      console.log('data', data);
      // if (this.role.edit) {
      //   this.$router.push({path: `/admin/list-service-order/view/${data.id}`, query: { page_transaction: (new Date()).getTime().toString() }});
      // }
    },
    changeFilterData(data) {
      this.filterData = {};
      for (const [key, value] of Object.entries(data)) {
        this.filterData[key] = value.value;
      }
    },
    selectedService(data) {
      this.selected = data;
      if (this.filterData?.ids) {
        delete this.filterData.ids;
      }
      if (this.selected && this.selected.length > 0) {
        let arr = [];
        this.selected.map(m => {
            arr.push(m.id);
        })
        if (arr.length > 0) {
          this.filterData.ids = arr;
        }
      }
    },
    async exportCSV() {
      this.$commonFuction.is_loading(true);
      const headers = {
        "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
      };
      
      if (this.list_order_item_id.length > 0) {
        this.filterData.ids = this.list_order_item_id;
      }
      var dataUpd = {filter: this.filterData}
      await ApiRepository.post('_api/common/export_excel_service_order', dataUpd, {headers}).then((res) => {
        console.log(res);
        if(res?.data?.data?.excelFile) {
          window.open(res?.data?.data?.excelFile);
        }
        this.$commonFuction.is_loading(false);
      }).catch(async error => {
        console.log('error', error);
        this.$toast.add({
          severity: 'error',
          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000
        });
        this.$commonFuction.is_loading(false);
      })
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      await this.callbackOptions();
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields();
      for (let index = 0; index < fields.length; index++) {
        var attributes = [];
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          // console.log("SDFGHJK",element)
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_ = {}
          var result;
          if (element['name'] == 'group_channel_name') {
            where_ = {
              active: { _eq: true },
              deleted: { _eq: false },
            }
          }
          if (element['name'] == 'channel_name') {
            where_ = {
              active: { _eq: true },
              deleted: { _eq: false },
            }
          }
          if (element['name'] == "service_name") {
            // console.log("element",element)
            let { data } = await this.$apollo.query({
              query: DataServices.getList("service", { "fields": "id name" }),
              variables: {
                where_key: {
                  deleted: { _eq: false },
                  parent_id: { _is_null: true }
                },
                orderBy: [{ ordinal: 'desc' }, { created_at: 'desc' }]
              }
            })
            if (data) {
              result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({ value: ele[attributes[0]], label: ele[attributes[1]] })
                }
              }
            }
          } else {
            if (element['name'] == 'group_channel_name') {
              where_ = {
                "channel": {
                  "deleted": {
                    "_eq": false
                  }
                },
                "deleted": {
                  "_eq": false
                }
              }
            } else {
              if (element.where_option) {
                where_ = element.where_option
              }
            }
            let { data } = await this.$apollo.query({
              query: DataServices.getList(element.models.tableName, { "fields": attributes.join(',') }),
              variables: { where_key: where_ }
            })
            if (data) {
              result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({ value: ele[attributes[0]], label: ele[attributes[1]] })
                }
              }
            }
          }
          // console.log("optionsData",optionsData)
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options) result = field.options;
        else if (field.models && this.options[name]) result = this.options[name];
      } else {
        if (field.options) { result = field.options; }
        else if (field.models && this.options[name]) result = this.options[name];
        else {
          result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
        }
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // if (this.role.add) {
      //   actions.header = { name: 'add', icon: 'plus', path: `list-service-order/add` };
      // }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
       // buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-service-order/view/` };
        if (that.role.edit) {
          if(rowData?.is_read == false){
            buttons.read = { name: 'read', icon: 'folder', key: 'id', path: `list-service-order/view/` };
          }
          buttons.edit_note = { name: 'edit_note', icon: 'external-link', key: 'id', path: `list-service-order/view/` };
       }
        // if (that.role.edit) {
        //   buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/`};
        // }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        if (that.role.delete) {
          buttons.delete = { name: 'delete', icon: 'trash', key: 'id' }
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (data.data?.status == 'ST002') {
            this.$router.push({ path: `/admin/list-visit/edit/${data.data?.order?.visit?.id}` })
            return;
          }
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111" + pageTransaction, payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key], query: { page_transaction: pageTransaction.toString() } })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'read':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.readId = data.data[action.key]
          this.showReadDialog = true
          break
        case 'edit_note':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.AdminNoteId = data.data[action.key]
          this.AdminNoteString = data.data["admin_note"]
          this.showAdminNoteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      let variables = {
        'data_update': { deleted: true },
        'where_key': {
          'id': { '_eq': this.deleteId }
        }
      }
      await this.$apollo.mutate({
        mutation: DataServices.updateData('log_management'),
        variables: variables
      }).then(async (res) => {
        console.log("res", res);
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Delete data successfully', life: 3000 })
        this.componentKey++;
      });
    },
    async readData() {
      this.showReadDialog = false;
      let variables = {
        'data_update': { is_read: true },
        'where_key': {
          'id': { '_eq': this.readId }
        }
      }
      await this.$apollo.mutate({
        mutation: DataServices.updateData('log_management'),
        variables: variables
      }).then(async (res) => {
        console.log("res", res);
        //this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Delete data successfully', life: 3000 })
        this.componentKey++;
      });
    },
     async adminNoteData() {
      this.showAdminNoteDialog = false;
      let variables = {
        'data_update': { admin_note: this.AdminNoteString },
        'where_key': {
          'id': { '_eq': this.AdminNoteId }
        }
      }
      await this.$apollo.mutate({
        mutation: DataServices.updateData('log_management'),
        variables: variables
      }).then(async (res) => {
        console.log("res", res);
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
        this.componentKey++;
      });
    }
  },
   
  

}
</script>
<style lang="css">
.p-calendar .p-datepicker {
  width: 280px;
  padding: 0px;
  padding-top: 5px;
}

.p-calendar .p-datepicker td,
.p-calendar .p-datepicker td a {
  padding: 0px !important;
}

.p-calendar .p-datepicker td span {
  padding: 0px !important;
  width: 30px !important;
  height: 30px !important;
}

.p-datepicker .p-datepicker-header {
  padding: 5px !important;
}

.p-button-warning .p-button-label {
  color: #1D76BC;
}

.p-button-warning .pi-times {
  color: #1D76BC;
}

.color-box {
  height: 30px;
  width: 30px;
  margin-right: 10px;
}
</style>